var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',{staticClass:"message-alert mx-auto mt-2",attrs:{"border":"left","colored-border":"","type":_vm.alertType,"elevation":"1"},model:{value:(_vm.showAlert),callback:function ($$v) {_vm.showAlert=$$v},expression:"showAlert"}},[_vm._v(" "+_vm._s(_vm.alertMessage)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }